import React from 'react';
import { useLocation } from 'react-router-dom';

import ListsNavigation from '../components/content/lists/ListsNavigation';
import Layout from '../components/layout/Layout';
import MetaTags from '../components/meta/MetaTags';

function ListsPage() {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/$/, '') || '/';
  const isListsHubOnly = path === '/lists';

  return (
    <div>
      {/* Hub SEO only on /lists — nested routes (county, trips, etc.) set their own MetaTags */}
      {isListsHubOnly ? (
        <MetaTags
          title="Golf Lists Navigation Header"
          description="Navigation menu for choosing which Golf List to explore."
          imageUrl="https://stjbqlfgvlefqghlyumg.supabase.co/storage/v1/object/public/brand/GL_LOGO_300_302.png"
          url="https://golflists.com/lists"
          keywords="GolfLists, List Navigation, golf courses, golf trips, golf practice facilities, golf tools and golf entertainment."
        />
      ) : null}

      <Layout>
        <ListsNavigation />
      </Layout>
    </div>
  );
}

export default ListsPage;
